import { Box, Button, Heading, Text, VStack, Badge } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import TicketDownloadButton from "../..//CustomReusables/TicketDownloadButton";
import { useCustomTheme } from "../../../contexts/CustomThemeContext";

const cardsBorderRadii="8px";

const BookingSuccessPage = () => {
    const { bookingId } = useParams<{ bookingId: string; }>();
    const navigate = useNavigate();
    const { theme } = useCustomTheme();

    const isDark = theme.name === "dark";

    return (
        <Box
            w="100%"
            p={{ base: 4, md: 6 }}
            mx="auto"
            bg={theme.background}
            minH="100%"
        >
            <Box
                maxW="720px"
                mx="auto"
                textAlign="center"
                bg={theme.surface}
                border={`1px solid ${theme.border}`}
                borderRadius={cardsBorderRadii}
                boxShadow={theme.shadowMd}
                p={{ base: 6, md: 8 }}
                backdropFilter={isDark ? "blur(8px)" : undefined}
            >
                <VStack spacing={6}>
                    <Badge colorScheme="green" px={3} py={1} borderRadius={cardsBorderRadii}>
                        Booking Confirmed
                    </Badge>

                    <Heading size="lg" color={theme.text}>
                        🎉 Trip Booked Successfully!
                    </Heading>

                    <Text fontSize="md" color={theme.textMuted}>
                        Thank you for booking with PickDengu.
                    </Text>

                    <Text fontWeight="700" color={theme.text}>
                        Booking ID: {bookingId || "—"}
                    </Text>

                    <TicketDownloadButton
                        bookingId={bookingId || ""}
                        user={{
                            name: "Lovemore",
                            surname: "Sinkonde",
                            email: "lovemore@example.com",
                        }}
                    />

                    <Button
                        variant="ghost"
                        color={theme.text}
                        _hover={{
                            bg: isDark ? "rgba(255,255,255,0.05)" : "rgba(42,44,59,0.04)",
                        }}
                        onClick={() => navigate("/")}
                    >
                        Back to Home
                    </Button>
                </VStack>
            </Box>
        </Box>
    );
};

export default BookingSuccessPage;